import {CompetitionPageMetaDataModel} from "../../../models/competition-page.meta-data.model";
import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";

export class CompetitionStatsPageRouteMetaDataModel extends CompetitionPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITION.stats)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITION.stats)
    }

    return description
  }

  get staticTitle() {
    const statsTitle = this.websiteTerms.WEB_COMPETITION_STATS_TITLE_TEMPLATE.format({
      COMPETITION_NAME: this.competitionName,
      WEB_COMPETITION_STATS_TERM_IN_TITLE: this.websiteTerms.WEB_COMPETITION_STATS_TERM_IN_TITLE
    });

    return statsTitle;
  }

  get staticDescription() {
    return this.websiteTerms.COMPETITION_BRACKET_DESCRIPTION.format({
      "LIVESCORE_MAIN_KEYWORD": this.websiteTerms.LIVESCORE_MAIN_KEYWORD,
      "COMPETITION_NAME": this.competitionName,
      "BRACKET_NAME": this.bracketsName,
      "COMPETITION_BRACKET_NAME": this.bracketsName,
    });
  }
}